import React from 'react'

import img1 from '../../imgs/saude-bucal/agravos-bucais/img-1.png'
import img2 from '../../imgs/saude-bucal/agravos-bucais/img-2.png'
import img3 from '../../imgs/saude-bucal/agravos-bucais/img-3.png'
import img4 from '../../imgs/saude-bucal/agravos-bucais/img-4.png'
import img5 from '../../imgs/saude-bucal/agravos-bucais/img-5.png'
import img6 from '../../imgs/saude-bucal/agravos-bucais/img-6.png'
import img7 from '../../imgs/saude-bucal/agravos-bucais/img-7.png'
import img8 from '../../imgs/saude-bucal/agravos-bucais/img-8.png'
import { useIsMobile } from '../../hooks/useIsMobile'

export default function PrincipaisAgravosBucais() {
    const isMobile = useIsMobile();
    return (
        <div style={{ paddingTop: 60, backgroundColor: '#fecfbc', paddingBottom: 120 }} className='container' >
            <img src={img1} alt="" style={{ width: '100%' }} />
            <br />
            <h2 style={{ textAlign: 'center', fontSize: 28 }}>Progressão da cárie dentária</h2>
            <p style={{ fontSize: 16 }}>Pode iniciar como uma lesão pequena e se <b>NÃO</b> for <b>TRATADA</b> pode comprometer a polpa do dente!</p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <img src={img2} style={{ width: '100%' }} alt="Fases da progressão da cárie" />

            </div>
            <img src={img3} alt="" style={{ width: '100%' }} />
            <br />

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <h3 style={{ fontSize: 18, textAlign: 'center' }}>Uma imagem que exemplifica a gengivite: gengivas vermelhas e inchadas!</h3><br />
                <img src={img4} alt="" style={{ width: '60%' }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <h3 style={{ marginBottom: 0, fontSize: 18, textAlign: 'center' }}>Progressão da gengivite para periodontite, podendo levar a perda do dente!</h3>
                <img src={img5} alt="" style={{ width: '60%' }} />
                <img src={img6} alt="" style={{ width: '100%' }} />
            </div>

            <h2 style={{ textAlign: 'center', fontSize: 18 }}>Se você pratica esportes, uma dica é utilizar protetores bucais para prevenir traumas dentários!</h2>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', marginBottom: 90 }}>
                <img src={img7} alt="" style={{ width: isMobile ? 150 : 300, marginRight: 20 }} />
                <img src={img8} alt="" style={{ width: isMobile ? 150 : 400, height: isMobile ? 110 : 'auto' }} />
            </div>

            <div syle={{ paddingBottom: 120 }}></div>

        </div>
    )
};